import React, { useCallback, useState } from "react";
import { IconButton } from "@mui/material";
import { ClinicColors } from "fe-web-components/styles/clinicTheme";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import debounceFn from "debounce-fn";
import { FormInput } from "fe-web-components/layout/formInput";
import { makeStyles } from "@mui/styles";

//region [[ Styles ]]

const useStyles = makeStyles({
  searchInput: {
    borderColor: ClinicColors.selectedBg,
    background: "transparent",
    fontSize: 13,
    width: 240,
    "& .MuiOutlinedInput-root": {
      paddingLeft: 4,
    },
    "& input": {
      background: "transparent",
      padding: "7px 9px 7px 2px !important",
    },
    "& svg": {
      fill: ClinicColors.secondary,
    },
  },
});

//endregion [[ Styles ]]

//region [[ Props ]]

export interface SearchInputProps {
  value?: string;
  searchOnChange?: boolean;
  placeHolder?: string;
  debounce?: number;
  onSearch: (searchTerm: string) => void;
  onClear: () => void;
}

//endregion [[ Props ]]

//region [[ Functions ]]

//endregion [[ Functions ]]

export const SearchInput = ({ ...props }: SearchInputProps) => {
  const classes = useStyles();
  const [searchTerm, setSearchTerm] = useState(props.value || "");

  const { onSearch, debounce } = props;
  const debounceSearch = useCallback(() => {
    return debounceFn((term: string) => onSearch(term.trim()), {
      wait: debounce || 400,
    });
  }, [onSearch, debounce]);

  return (
    <FormInput
      className={classes.searchInput}
      onChange={(e) => {
        setSearchTerm(e.target.value);
        if (props.searchOnChange) debounceSearch()(e.target.value);
      }}
      onKeyDown={(e) => {
        if (e.key === "Enter") props.onSearch(searchTerm.trim());
      }}
      value={searchTerm}
      placeHolder={props.placeHolder || "Search"}
      inputPrefix={
        <IconButton
          onClick={() => props.onSearch(searchTerm.trim())}
          size={"small"}
        >
          <SearchIcon fontSize={"small"} />
        </IconButton>
      }
      inputSuffix={
        searchTerm && (
          //reset search term
          <IconButton
            onClick={() => {
              setSearchTerm("");
              props.onClear();
            }}
            size={"small"}
            style={{ marginRight: -10 }}
            title={"Clear Search"}
          >
            <CloseIcon fontSize={"small"} />
          </IconButton>
        )
      }
    />
  );
};
